stimulusApp.register(
  "cruise-gallery",
  class extends Stimulus.Controller {
    static targets = ["caption", "thumb"]

    sync(event) {
      const thumb = this.thumbTargets[event.detail.index]
      if (!thumb) return

      if (this.hasCaptionTarget) {
        this.captionTarget.textContent = thumb.dataset.caption
      }

      this.thumbTargets.forEach((candidate) =>
        candidate.classList.toggle(
          "cruise-cabin-modal--thumb_active",
          candidate === thumb,
        ),
      )

      thumb.scrollIntoView({ block: "nearest", inline: "nearest" })
    }
  },
)
